/**
 * @generated SignedSource<<d03265939ab3d7411c3822a37aadeac6>>
 * @relayHash 1cb886365bb9c572de10198d6edd0748
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 065351ad3c4d218094c1e7f4071ae68aec98e6836ef7d2bc2e31a0b0382734e8

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { JiraBusinessListEmbedAppQuery } from './JiraBusinessListEmbedAppQuery.graphql';

const node: PreloadableConcreteRequest<JiraBusinessListEmbedAppQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "065351ad3c4d218094c1e7f4071ae68aec98e6836ef7d2bc2e31a0b0382734e8",
    "metadata": {},
    "name": "JiraBusinessListEmbedAppQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
